(() => {
  const ROOT = '[data-garment-lookbook]';

  const shuffle = (items) => {
    const copy = items.slice();
    for (let i = copy.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [copy[i], copy[j]] = [copy[j], copy[i]];
    }
    return copy;
  };

  const imageUrl = (product) => {
    if (!product) return '';
    if (Array.isArray(product.images) && product.images.length) {
      const image = product.images[0];
      return typeof image === 'string' ? image : (image.src || image.url || '');
    }
    const image = product.featured_image;
    return typeof image === 'string' ? image : (image && (image.src || image.url)) || '';
  };

  const fetchPage = async (root, handle, page) => {
    const response = await fetch(`${root}collections/${encodeURIComponent(handle)}/products.json?limit=250&page=${page}`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error(`Garment fabrics request failed: ${response.status}`);
    const data = await response.json();
    return Array.isArray(data.products) ? data.products : [];
  };

  const usable = (products) => products.filter((product) => product && product.handle && imageUrl(product));

  const load = async (lookbook) => {
    if (!lookbook || ['loading', 'loaded'].includes(lookbook.dataset.garmentStatus)) return;
    const handle = lookbook.dataset.collectionHandle;
    if (!handle) return;
    lookbook.dataset.garmentStatus = 'loading';

    const shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const count = Number.parseInt(lookbook.dataset.productCount, 10) || 250;
    const maxPage = Math.max(1, Math.ceil(count / 250));
    const page = 1 + Math.floor(Math.random() * maxPage);

    try {
      let products = usable(await fetchPage(shopRoot, handle, page));
      if (products.length < 3 && page !== 1) {
        const fallback = usable(await fetchPage(shopRoot, handle, 1));
        const known = new Set(products.map((product) => product.handle));
        fallback.forEach((product) => {
          if (!known.has(product.handle)) {
            known.add(product.handle);
            products.push(product);
          }
        });
      }

      const selected = shuffle(products).slice(0, 3);
      const garments = lookbook.querySelectorAll('[data-garment-link]');
      garments.forEach((garment, index) => {
        const product = selected[index];
        if (!product) return;
        const source = imageUrl(product);
        const image = garment.querySelector('[data-garment-image]');
        const title = garment.querySelector('[data-garment-title]');
        if (image) {
          image.setAttribute('href', source);
          image.setAttributeNS('http://www.w3.org/1999/xlink', 'href', source);
        }
        garment.href = `${shopRoot}products/${encodeURIComponent(product.handle)}`;
        garment.setAttribute('aria-label', `See ${product.title} used as garment inspiration`);
        if (title) title.textContent = product.title;
        garment.classList.add('is-loaded');
      });
      lookbook.dataset.garmentStatus = selected.length === 3 ? 'loaded' : 'partial';
    } catch (error) {
      lookbook.dataset.garmentStatus = 'error';
      console.warn('Garment lookbook fabrics could not be loaded.', error);
    }
  };

  const initialize = (scope = document) => {
    if (scope.matches && scope.matches(ROOT)) load(scope);
    if (scope.querySelectorAll) scope.querySelectorAll(ROOT).forEach(load);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();